import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import "nprogress/nprogress.css";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import Vuelidate from "vuelidate";
import toastr from "@/utils/properties/toastMessage";
import loader from "@/utils/overlay/pageLoading";
import VueLoading from "vuejs-loading-plugin";
import Tooltip from "primevue/tooltip";
import ConfirmationService from "primevue/confirmationservice";
import BadgeDirective from "primevue/badgedirective";
import { btooltip } from "@/utils/helpers/directive";
import "@/utils/helpers/filters";
import { setupInterceptor } from "@/services/ApiService";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import VueTelInput from "vue-tel-input";

import "popper.js";
import "bootstrap";
//import application theme style
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import "vue-tel-input/dist/vue-tel-input.css";
import "@/assets/styles/style.scss";

/**
 * The following piece of code, will setup base components(common components/controls) for the application/
 * If you need to create an Base Component like BaseInput, BaseButton, etc just create a file in the components folder following
 * BaseButton convention and it will automatically register that component in the vue instance for the whole app.
 *
 */

const requireComponent = require.context(
  // The relative path of the components folder
  "./components/base",
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

Vue.use(PrimeVue, { ripple: true });
Vue.use(Vuelidate);
Vue.use(ToastService);
Vue.use(VueTelInput);
Vue.use(toastr);
Vue.use(loader);
Vue.use(VueLoading, {
  classes: ["page-loader"],
  text: "Please wait...",
});
Vue.use(PerfectScrollbar);

Vue.directive("tooltip", Tooltip);
Vue.directive("badge", BadgeDirective);
Vue.directive("btooltip", btooltip);
Vue.use(ConfirmationService);

Vue.config.productionTip = false;

setupInterceptor(Vue);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
